var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormsProvider,_vm._b({},'FormsProvider',_setup.formsConfig,false),_vm._l((_setup.renderedBlocks),function(block){return _c(block.component,_vm._g(_vm._b({key:block.key,tag:"component"},'component',block.props,false),_setup.getEventHandlers(block.type)))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }